import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';

@Component({
  selector: 'cp-better-deal-info-message',
  imports: [CommonModule, IconComponent],
  templateUrl: './better-deal-info-message.component.html',
  styleUrl: './better-deal-info-message.component.scss',
})
export class BetterDealInfoMessageComponent {
  @Input({ required: true }) savedOnInitialRatePayment: number;
  @Input({ required: true }) savingsInComparisonPeriod: number;
  @Input({ required: true }) comparisonPeriod: number;
  @Input() isBiggestSaving = false;
}
